import { useCallback } from "react";

export const useUrlFilters = (defaultValue: string | null = null) => {
  const setParam = useCallback(
    (
      key: string,
      value: string | number | boolean | undefined | null,
      internalDefaultValue = defaultValue
    ) => {
      const url = new URL(window.location.href);
      const { searchParams } = url;

      if (
        value === null ||
        value === undefined ||
        value === internalDefaultValue
      ) {
        searchParams.delete(key);
      } else {
        searchParams.set(key, String(value));
      }

      url.search = searchParams.toString();
      const newUrl = url.toString();
      // eslint-disable-next-line no-restricted-globals
      history.replaceState("", "", newUrl);
    },
    [defaultValue]
  );

  const setParams = useCallback(
    (params: Record<string, string | number | boolean | undefined | null>) => {
      const url = new URL(window.location.href);
      const { searchParams } = url;

      const entries = Object.entries(params);
      if (entries.length == 0) {
        for (const [key] of searchParams.entries()) {
          searchParams.delete(key);
        }
      } else {
        entries.forEach(([key, value]) => {
          if (value === null || value === undefined || value === defaultValue) {
            searchParams.delete(key);
          } else {
            // Convert number to string if necessary; strings are used as-is
            searchParams.set(key, String(value));
          }
        });
      }
      url.search = searchParams.toString();
      const newUrl = url.toString();
      // eslint-disable-next-line no-restricted-globals
      history.replaceState("", "", newUrl);
    },
    [defaultValue]
  );

  return { setParam, setParams };
};
